import { render } from "./StartItems.vue?vue&type=template&id=4f231b3c&scoped=true"
import script from "./StartItems.vue?vue&type=script&lang=js"
export * from "./StartItems.vue?vue&type=script&lang=js"

import "./StartItems.vue?vue&type=style&index=0&id=4f231b3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f231b3c"]])

export default __exports__